import * as React from 'react';
import { IgcGridPinningActionsComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Grid Pinning Actions for the Action Strip
 */
export const IgrGridPinningActions = createComponent({
  tagName: 'igc-grid-pinning-actions',
  displayName: 'IgrGridPinningActions',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridPinningActions = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridPinningActionsModule = Component;
